<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Servers
        <small>Informations about servers</small>
      </h1>

    </section>

    <!-- Main content -->
    <section class="content">
      <div class="box-body">
        <ol>
          <li v-for="server in servers">

            {{ server.name }}
            <ul>
              <li>ID: {{ server.shortUrl }}</li>
              <li>Short name: {{ server.short_name }}</li>
              <li>IP: {{ server.ip }}:{{ server.gamePort }}</li>
              <li v-if="server.ips">IP secure: {{ server.ips }}:{{ server.gamePort }}</li>
              <li>Stats port: {{ server.statPort }}</li>

            </ul>
          </li>
        </ol>
      </div>

    </section>
    <!-- /.content -->
  </div>
</template>

<script>
  export default {
    name: 'ServersData',
    data: function () {
      return {
        servers: [],
        role: 1,
        form: new Form({})
      }
    },
    mounted: function () {
      this.role = this.$store.state.role
      var self = this
      this.form.post(baseUrl2 + '/data/servers.php', {}).then(function (result) {
        self.servers = result.servers
      }, function (reason) {
          // rejection
        console.log('Rejected', reason)
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// Data.vue?55a551d2